// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { useStepsData } from '@shared/ui-kit';
import { useMemo } from 'react';
import { useAccountWorkflowData } from '../../providers';
import { isUndefined } from '@shared/utils';

export const useBackNavigationGuard = (isFirstStep: boolean) => {
  const { stepIndex, steps } = useStepsData();
  const { navigationFloorStepId, workflow } = useAccountWorkflowData();

  const navigationFloorIndex = useMemo(() => {
    if (workflow !== 'combined' || !navigationFloorStepId) {
      return undefined;
    }

    let index = 0;

    for (const [id] of steps) {
      if (id === navigationFloorStepId) {
        return index;
      }

      index += 1;
    }

    return undefined;
  }, [navigationFloorStepId, steps, workflow]);

  const canGoBack = useMemo(() => {
    if (!isUndefined(navigationFloorIndex)) {
      return stepIndex > navigationFloorIndex;
    }

    return !isFirstStep;
  }, [isFirstStep, navigationFloorIndex, stepIndex]);

  return { canGoBack };
};
